import {useCallback, useSyncExternalStore} from "react";
import {useSecurityClient} from "./SecurityClientProvider";


export interface UseAuthenticationPrincipalType<TPrincipal> {
    isPending: boolean;
    isAuthenticated: boolean;
    principal: TPrincipal | undefined;
}

export function useAuthenticationPrincipal<TPrincipal>(): UseAuthenticationPrincipalType<TPrincipal> {
    const client = useSecurityClient<TPrincipal>()
    return useSyncExternalStore(
        useCallback((onStoreChange) => {
            return client.authenticationManager.subscribe(onStoreChange)
        }, [client.authenticationManager]),
        () => {
            return client.authenticationManager.getCurrentState();
        }
    )
}
